import {
    apiGetRequest,
    apiPostRequest,
} from "../utils/webrequests";

export async function createStripeCheckoutSession(
    eventId: string,
    userId: string,
    eventName: string,
    price: number
): Promise<{CheckoutUrl: string}> {
    try{
        const response = await apiPostRequest("CreateStripeCheckoutSession", {
            eventId,
            userId,
            eventName,
            price
        });
        return response;
    } catch (error: any) {
        throw new Error('Error creating Stripe Checkout session: ' + error.message);
    }
}

export async function confirmStripePayment(
    sessionId: string
): Promise<{success: boolean, eventId: string}> {
    try{
        const response = await apiPostRequest("ConfirmPayment", {
            sessionId
        });
        return response;
    } catch (error: any) {
        throw new Error('Error confirming payment: ' + error.Message);
    }
}